import { TablePagination, TablePaginationProps } from "@mui/material";

/**
 * Pagination component for comments.
 * Currently just wraps MUI's TablePagination with the same props.
 */
export function CommentPagination(props: TablePaginationProps) {
  return <TablePagination {...props} labelRowsPerPage={"Comments per page:"} />;
}
